export const flightIcon = require('./flight.png').default
export const logo = require('./logo.jpg').default;
export const AircraftSearchIcon = require('./aircraftSearchIcon.svg')
export const DoubleArrowRightIcon = require('./DoubleArrowRightIcon.svg');
export const DoubleArrowLeftIcon = require('./DoubleArrowLeftIcon.svg')
export const CloseIcon = require('./closeIcon.svg')
export const searchFlightIcon = require('./searchFlight.png').default